import { useQuery } from '@tanstack/react-query';

import { Field } from '../../../healtheraComponents';
import useDebouncedSearchTerm from '../../../hooks/useDebouncedSearchTerm';
import citiesApi from '../../../apis/cities';
import styled from 'styled-components';

export default function CitySearch({ onSelectCity }) {
  const { setValue, immediateValue, debouncedValue } = useDebouncedSearchTerm('');

  const { data: cities } = useQuery({
    queryKey: ['search-city', debouncedValue],
    queryFn: async () => citiesApi.searchCities({ searchTerm: debouncedValue }),
    enabled: debouncedValue.length >= 3,
    initialData: null
  });

  return (
    <div>
      <Field placeholder="Type to search for a city" value={immediateValue} onChange={e => setValue(e.target.value)} />
      {cities !== null && (
        <SearchResultsBox>
          {cities?.length === 0 && <div>No cities found</div>}
          {cities?.length > 0 && (
            <div>
              {cities.map(city => (
                <SelectCityOption key={city._id} onClick={() => onSelectCity(city._id)}>
                  {[city.country, city.county, city.region, city.city].filter(Boolean).join(' - ')}
                </SelectCityOption>
              ))}
            </div>
          )}
        </SearchResultsBox>
      )}
    </div>
  );
}

const SearchResultsBox = styled.div(() => ({
  border: '1px solid #ccc',
  borderRadius: '4px'
}));

const SelectCityOption = styled.div(() => ({
  padding: '2px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#f9f9f9'
  }
}));
